import "../landingPage/Landing.css";
import imageRight from "../../medias/images/ImageRight.png"

function LandingCenter() {
  return (
    <div className="landing-center">
      <div className="landing-center-text">
        <div className="landing-center-text-header">
          Get the Most out of Your Employees’ Time
        </div>
        <div className="landing-text">
          Employee tracking software that tells you exactly how your employees
          use their time. Get powerful data for a more productive and efficient
          team.
        </div>
      </div>
      <img
        className="landing-center-image-right"
        src={imageRight}
        alt="Wisdom Features"
        />
    </div>
  );
}

export default LandingCenter;
